import { IconProps } from 'src/utils/icon';

const PPTIcon: React.FC<IconProps> = ({ size = 1, fill = '#2C2A29' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4859 3.44165L10.4271 0.492041C10.099 0.175635 9.65417 -0.00366211 9.19115 -0.00366211H1.75C0.783854 -0.000146484 0 0.755713 0 1.68735V16.3124C0 17.244 0.783854 17.9999 1.75 17.9999H12.25C13.2161 17.9999 14 17.244 14 16.3124V4.63696C14 4.19048 13.8141 3.75806 13.4859 3.44165ZM12.662 4.2397C12.7385 4.31353 12.7896 4.40142 12.8151 4.49985H9.33333V1.14243C9.43542 1.16704 9.52656 1.21626 9.60312 1.29009L12.662 4.2397ZM12.25 16.8749H1.75C1.42917 16.8749 1.16667 16.6217 1.16667 16.3124V1.68735C1.16667 1.37798 1.42917 1.12485 1.75 1.12485H8.16667V4.7811C8.16667 5.24868 8.55677 5.62485 9.04167 5.62485H12.8333V16.3124C12.8333 16.6217 12.5708 16.8749 12.25 16.8749ZM7.44844 7.31235H5.10417C4.86354 7.31235 4.66667 7.5022 4.66667 7.73423V14.203C4.66667 14.435 4.86354 14.6249 5.10417 14.6249H5.39583C5.63646 14.6249 5.83333 14.435 5.83333 14.203V12.0795H7.44844C8.85938 12.0795 9.91667 11.1198 9.91667 9.65376C9.91667 8.29673 9.04896 7.31235 7.44844 7.31235ZM8.39635 10.7471C8.12292 11.0143 7.7474 11.1479 7.26615 11.1479H5.83333V8.19126H7.28073C7.75104 8.19126 8.12292 8.32134 8.39635 8.58149C8.95417 9.11235 8.94323 10.2163 8.39635 10.7471Z"
      fill={fill}
    />
  </svg>
);

export default PPTIcon;
